export default {"src":"/_next/static/media/chevronRightUiOrange_16.4af6801f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};